import { ReasonOrError } from "../ErrorUntyped";

export class AggregatedError extends Error {
    public readonly errors: ReasonOrError[];

    public constructor(message: string, ...errors: ReasonOrError[]) {
        super(message);
        Object.setPrototypeOf(this, AggregatedError.prototype);
        this.errors = errors;
    }
}
